import { useToast } from "@chakra-ui/react";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { useTrackChartInteractions } from "modules/charts-shared/api/mutations/useTrackChartInteractions";
import { SharedInteractionChange } from "modules/charts-shared/utils/sharedSectionInteractions";

export function useTrackSharedSectionChanges(
  encounterId: string,
  sectionId: string,
  chartCode?: string
) {
  const { mutateAsync: track } = useTrackChartInteractions();
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();
  const toast = useToast();

  const trackChanges = async (
    changes: SharedInteractionChange[]
  ): Promise<void> => {
    if (changes.length === 0) return;
    setIsLoading(true);
    try {
      await track(
        changes.map((change) => ({
          encounterId,
          sectionId,
          chartCode,
          type: "shared" as const,
          code: change.code,
          label: change.label,
          elementType: change.elementType ?? "Text",
          action: !change.previousValue
            ? "added"
            : !change.value
            ? "removed"
            : "updated",
          previousValue: change.previousValue,
          newValue: change.value,
        }))
      );
      await queryClient.invalidateQueries([
        "sharedSectionInteractions",
        encounterId,
        sectionId,
      ]);
    } catch {
      toast({
        status: "error",
        description: "Unable to record interaction history.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return { trackChanges, isLoading };
}
